import { effects } from 'redux-saga'

import { forgetSignup } from '../../modules/signupEdit/actions'

export default function* forget(action) {
  if (action.payload.type !== 'signup') {
    return
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const id of action.payload.keys) {
    yield effects.put.resolve(forgetSignup(id))
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/forget.js